import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/desktop/42_national_park/42_national_park"
 * Contains 1 texture(s)
 */
export class Desktop42NationalParkAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/desktop/42_national_park/42_national_park';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '42_national_park.jpg'
    ] as const;
}
